import axios from "@/plugins/axios";

export default {
    findById(id) {
        return axios.httpApi.get("/stimulus/" + id);
    },
    create(payload){
        return axios.httpApi.post("/stimulus", payload);
    },
    update(id, payload) {
      return axios.httpApi.patch("/stimulus/" + id, payload);
    },
    updateList(payload) {
        return axios.httpApi.patch("/stimulus/edit_multiple", payload);
    },
    prepareStimulus(payload) {
        console.log(payload);
        return axios.httpApi.post("/stimulus/prepare_stimulus", payload);
    },
    updateOrder(id, payload) {
        return axios.httpApi.post("/stimulus/" + id + "/order", payload);
    },
    list(debt_base_id, active = true) {
        
        let params = {}

        if (debt_base_id) {
            params.debt_base_id = debt_base_id;
        }
        params.active = active
        params.limit = 9999
        return axios.httpApi.get("/stimulus", { params });
    },
    active_operation(debt_base_id, active = true){
        let params = {}

        if (debt_base_id) {
            params.debt_base_id = debt_base_id;
        }
        params.active = active
        params.limit = 9999
        return axios.httpApi.get("/stimulus/active_operation", { params });        
    },
    /**
     * Consuta o histórico.
     * 
     * debt_base_id=26&
     * group_by=created_at,approach_type,stimulus_id&
     * approach_types=SMS,EMAIL,PUSH&
     * limit=5
     * 
     * @param {Object} payload objeto com os filtros
     * @returns Array com os históricos
     */
    history(payload = {}) {
        let url = "/stimulus-history/"
        let defaultPayload = {
            debt_base_id: "",
            sitmulus_id: "",
            group_by: "",
            approach_types: "",
            limit: "",
        };

        url += "?";
        Object.entries(defaultPayload).forEach(([index, item]) => {
            if (payload[index]) url += index + "=" + payload[index] + "&";
            else if(item) url += index + "=" + item + "&";
        });
        url = url.replace(/.$/, '');

        return axios.httpApi.get(url);
    },
};